var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWesternSahara(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M0 8h30v8H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M30 8H0V0h30zm0 0H0V0h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a3d",
    d: "M0 16v8h30v-8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c4111b",
    d: "M0 24V0l14 12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c4111b",
    d: "M18.2 12.2a3.2 3.2 0 0 1 2.6-3.14 3.2 3.2 0 1 0 0 6.28 3.2 3.2 0 0 1-2.6-3.14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c4111b",
    d: "m19.34 14.14 1.37-.98 1.35 1-.5-1.6 1.36-.99-1.68-.01-.51-1.6-.53 1.6-1.68-.01 1.35 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWesternSahara);
export default __webpack_public_path__ + "static/media/western-sahara.3643384080828f8488dd138cfadb5242.svg";
export { ForwardRef as ReactComponent };